import * as React from 'react';
import styled from 'styled-components';

import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import Chart from '@process-advisor/process-miner/modals/lifecycle/chart';

import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    margin-top: 10px;
    margin-left: 10px; 
    margin-right: 10px;
    background-color: white
`;

const Options = styled.div`
    padding-left: 30px; 
    display: flex;
    justify-content: center;
`;

const ChartContainer = styled.div`
    max-height: 600px;
    height: 600px;
    min-height: 600px !important;
    overflow-y: auto;

    .ag-charts-wrapper {
        height: 600px !important;
    }
`;


import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';

let seriesData = []
let categoryData = []

export function VariantLifeCycle(){

    const optionsStepMetric = [
        { value: 0, label: 'Avg Duration (mins)' },
        { value: 1, label: 'Avg Duration (hrs)' },
        { value: 2, label: 'Avg Duration (days)' },
    ];
    
    const [graphType, setGraphType] = React.useState(1);
    const [stepMetric, setStepMetric] = React.useState(1);
    const [seriesData, setSeriesData] = React.useState([]);
    const [categoryData, setCategoryData] = React.useState([]);
    const [showYAxis, setShowYAxis] = React.useState(true);
    const [title, setTitle] = React.useState('');
    const [yAxisTitle, setyAxisTitle] = React.useState(optionsStepMetric[1].label);

    const onChangeStepMetric = (value) => {
        setStepMetric(value);
        setyAxisTitle(optionsStepMetric[value].label);
        apiProvider.setVariantsVisualizationMetric({metric: value})
        updateGraph()
    };
    
    React.useEffect(() => {
        const listener = () => {
            updateGraph()
        }
        listener();
        apiProvider.on(Event.openVariantLifecycleModal, listener);

        return () => {
            apiProvider.off(Event.openVariantLifecycleModal, listener);
        };
    }, []);

    React.useEffect(() => {
        setGraphType(1);
        setStepMetric(1)
        setyAxisTitle(optionsStepMetric[1].label)
        setShowYAxis(true)
        updateGraph()
    }, []);

    function updateGraph() {
        apiProvider.variantsVisualization()
        let tSeriesData = apiProvider.getLifecycleSeries().sort((a, b) => b.sort - a.sort)
        let tCategoryData = apiProvider.getLifecycleCategory().sort()
        setCategoryData(tCategoryData)
        setSeriesData(tSeriesData)
        setTitle('Variant Lifecycle')
    }

    
    return (
        <Wrapper>
            <Options>
                <SingleBlock width="10%">
                    <Section title='Step Metric:'/>
                </SingleBlock>
                <SingleBlock width="20%">
                    <Dropdown
                        options={optionsStepMetric}
                        onChange={onChangeStepMetric}
                        value={stepMetric} />
                </SingleBlock>
                <SingleBlock width="70%"/>
            </Options>
            <Chart
                title={title}
                graphType={graphType}
                stepMetric={stepMetric}
                showYAxis={showYAxis}
                yAxisTitle={yAxisTitle}
                seriesData={seriesData}
                categoryData={categoryData}>
            </Chart>
        </Wrapper>
    );
};
